import React from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface Props {
  columnCount: number;
}

export default function BlackoutTableHeader({ columnCount }: Props) {
  return (
    <TableHead>
      <TableRow
        sx={{
          '& .MuiTableCell-head': {
            bgcolor: (theme) => alpha(theme.palette.info.main, 0.14),
            color: 'info.dark',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
          },
        }}
      >
        <TableCell colSpan={columnCount}>Parent Salesforce blackout dates</TableCell>
      </TableRow>
      <TableRow
        sx={{
          '& .MuiTableCell-head': {
            bgcolor: (theme) => alpha(theme.palette.info.main, 0.06),
            color: 'info.dark',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
          },
        }}
      >
        <TableCell />
        <TableCell>Name</TableCell>
        <TableCell>Rooms (extracted)</TableCell>
        <TableCell>Range</TableCell>
        <TableCell>Days (extracted)</TableCell>
      </TableRow>
    </TableHead>
  );
}
